import {z} from "zod";

export const newsContextSchema = z.enum(["Team", "Club"])
export type NewsContext = z.infer<typeof newsContextSchema>

export const newsNotificationSchema = z.enum(['default','none']);

export const newsSchema = z.object({
  appId:z.string().max(10),
  _id: z.string(),
  newsContext: newsContextSchema,
  title: z.string().min(3),
  releaseDate: z.number(),
  newsText: z.string().optional(),
  imagePath: z.string().url().optional(),
  contextId:z.string(),
  showInClubNews:z.boolean().optional(),
  notifications: newsNotificationSchema.default('default'),
  deleted:z.boolean().optional(),
  createdAt: z.number(),
  createdBy: z.string(),
  updatedAt: z.number().optional(),
  updatedBy: z.string().optional()
})

export type News = z.infer<typeof newsSchema>

export const newsFormDataSchema = newsSchema.pick({title:true, releaseDate: true, newsText: true, imagePath: true, showInClubNews: true, notifications: true})
export type NewsFormData = z.infer<typeof newsFormDataSchema>

export const newsCreateRequestSchema =  newsSchema.omit({appId:true, _id: true, createdBy: true, createdAt: true, updatedAt: true, updatedBy: true, deleted: true})
export type NewsCreateRequest = z.infer<typeof newsCreateRequestSchema>

export const newsUpdateRequestSchema = newsSchema.omit({appId:true, createdBy: true, createdAt: true, updatedAt: true, updatedBy: true, deleted: true, title: true,releaseDate: true}).extend({releaseDate: z.number().optional(), title:z.string().optional()})
export type NewsUpdateRequest = z.infer<typeof newsUpdateRequestSchema>

export const newsDeleteRequestSchema = newsSchema.pick({_id: true, contextId: true, newsContext: true})
export type NewsDeleteRequest = z.infer<typeof newsDeleteRequestSchema>

export const newsGetRequestSchema = newsSchema.pick({_id: true});
export type NewsGetRequest = z.infer<typeof newsGetRequestSchema>

export const newsGetListRequestSchema =  newsSchema
  .pick({
    newsContext: true,
    contextId: true,
    showInClubNews: true
  })
  .extend({
    itemCount:z.string(),
    fromDate:z.string().optional(),
    toDate:z.string().optional()
  })
export type NewsGetListRequest = z.infer<typeof newsGetListRequestSchema>

export const newsListElementSchema =
  newsSchema
    .omit({appId:true, createdBy: true, createdAt: true, updatedAt: true, updatedBy: true, deleted: true})
    .extend({teamName: z.string().optional()})
export type NewsListElement = z.infer<typeof newsListElementSchema>

export interface NewsAdminStats {
  totalNews: number;
  activeNews: number;
  deletedNews: number;
}

export interface NewsAdminStatsDict {
  [appId: string]: NewsAdminStats;
}
